import { Section } from "@/components/Section";
import { SEO } from "@/components/SEO";
import { site } from "@/config/site";

const docs = {
    "polityka-prywatnosci": {
        title: "Polityka prywatności",
        sections: [
            { h: "1. Administrator danych", p: `Administratorem danych osobowych jest ${site.companyName}, kontakt: ${site.email}.` },
            { h: "2. Zakres danych", p: "Przetwarzamy dane podane w formularzu kontaktowym (imię, e-mail, telefon, firma, treść zapytania) wyłącznie w celu obsługi zapytania i ewentualnego przygotowania oferty." },
            { h: "3. Podstawa prawna", p: "Dane przetwarzamy na podstawie zgody (art. 6 ust. 1 lit. a RODO) oraz prawnie uzasadnionego interesu administratora (art. 6 ust. 1 lit. f RODO)." },
            { h: "4. Twoje prawa", p: "Masz prawo dostępu do swoich danych, ich sprostowania, usunięcia, ograniczenia przetwarzania oraz wniesienia skargi do Prezesa UODO." },
            { h: "5. Bezpieczeństwo", p: "Stosujemy odpowiednie środki techniczne i organizacyjne chroniące dane przed nieuprawnionym dostępem." },
        ],
    },
    "polityka-cookies": {
        title: "Polityka cookies",
        sections: [
            { h: "1. Czym są cookies", p: "Pliki cookies to małe pliki tekstowe zapisywane w przeglądarce użytkownika, służące poprawnemu działaniu strony i analityce." },
            { h: "2. Rodzaje cookies", p: "Używamy cookies niezbędnych do działania strony oraz – po Twojej zgodzie – cookies analitycznych i marketingowych." },
            { h: "3. Zarządzanie cookies", p: "Możesz w dowolnym momencie wyłączyć cookies w ustawieniach swojej przeglądarki." },
        ],
    },
    regulamin: {
        title: "Regulamin",
        sections: [
            { h: "1. Zakres usług", p: `Niniejszy regulamin określa zasady korzystania ze strony ${site.companyName} oraz świadczonych przez nią usług.` },
            { h: "2. Zawarcie umowy", p: "Każda współpraca poprzedzona jest indywidualną ofertą i pisemnym potwierdzeniem zakresu prac." },
            { h: "3. Płatności", p: "Warunki płatności określane są indywidualnie w umowie lub ofercie." },
            { h: "4. Postanowienia końcowe", p: "W sprawach nieuregulowanych zastosowanie mają przepisy prawa polskiego." },
        ],
    },
};

export default function Legal({ doc }) {
    const d = docs[doc];
    if (!d) return null;
    return (
        <>
            <SEO title={`${d.title} – Szymkas Agency`} description={d.title} />
            <section className="bg-[#06111F] text-white pt-32 pb-12 md:pt-40 md:pb-16 relative overflow-hidden">
                <div className="absolute inset-0 bg-grid-faint opacity-50" />
                <div className="relative max-w-3xl mx-auto px-5 md:px-8">
                    <h1 className="font-display font-extrabold text-[32px] md:text-[48px] leading-tight tracking-tight">{d.title}</h1>
                </div>
            </section>
            <Section variant="light">
                <div className="max-w-3xl mx-auto space-y-8 text-[#0B1220]/85 text-base md:text-lg leading-relaxed">
                    {d.sections.map((s, i) => (
                        <div key={i}>
                            <h2 className="font-display font-bold text-xl md:text-2xl text-[#0B1220] mb-2">{s.h}</h2>
                            <p>{s.p}</p>
                        </div>
                    ))}
                    <p className="text-sm text-[#0B1220]/50 pt-6 border-t border-[#E5E7EB]">
                        Dokument przygotowany jako wersja wstępna. Pełna wersja zostanie uzupełniona po podaniu danych rejestrowych firmy.
                    </p>
                </div>
            </Section>
        </>
    );
}
